// extracted by mini-css-extract-plugin
export default {"nfc-container":"NFC_nfc-container__EYSKK","nfc-info":"NFC_nfc-info__rHFzw","nfc-image":"NFC_nfc-image__3A9-0"};